module.exports = __webpack_public_path__ + "img/eg-hk-01.af6bc118.png";